function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-user-circle-2",
  "data-name": "Icon awesome-user-circle",
  d: "M16.5.562A16.5,16.5,0,1,0,33,17.062,16.5,16.5,0,0,0,16.5.562Zm0,6.387A5.855,5.855,0,1,1,10.645,12.8,5.855,5.855,0,0,1,16.5,6.95Zm0,22.887A12.749,12.749,0,0,1,6.753,25.3a7.418,7.418,0,0,1,6.553-3.979,1.628,1.628,0,0,1,.472.073,8.809,8.809,0,0,0,2.721.459,8.776,8.776,0,0,0,2.721-.459,1.628,1.628,0,0,1,.472-.073A7.418,7.418,0,0,1,26.247,25.3,12.749,12.749,0,0,1,16.5,29.837Z",
  transform: "translate(0 -0.563)",
  fill: "#707070"
});

function SvgUserDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_awesome-user-circle",
    "data-name": "Icon awesome-user-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefault);
export default __webpack_public_path__ + "static/media/userDefault.b53b77c56a6ed95983c25fb0de932548.svg";
export { ForwardRef as ReactComponent };